import { render } from "./KidsPage.vue?vue&type=template&id=c0e6b734&scoped=true"
import script from "./KidsPage.vue?vue&type=script&lang=js"
export * from "./KidsPage.vue?vue&type=script&lang=js"

import "./KidsPage.vue?vue&type=style&index=0&id=c0e6b734&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-c0e6b734"]])

export default __exports__